export default "/copy.13bb70caee7ff3875ab27aecf5eaefc2.svg";